import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRtmpLive } from "../../redux/lives/livesSlice";
import { AppDispatch, StoreState } from "../../redux/store";

const useFetchRTMPStream = () => {
  const dispatch = useDispatch<AppDispatch>();
  const shouldFetch = useRef(true);
  const { rtmpLive, rtmpLiveLoading, error } = useSelector((state: StoreState) => state.lives);

  useEffect(() => {
    if (!rtmpLive && shouldFetch.current && !rtmpLiveLoading) {
      shouldFetch.current = false;
      dispatch(getRtmpLive());
    }
  }, [rtmpLive, dispatch, rtmpLiveLoading]);

  return { rtmpLiveLoading, error, rtmpLive };
};

export default useFetchRTMPStream;
